import { ActionType, LoginWindowChangedAction } from './actiontypes';
import { LoginWindowState } from '@/state';
import { Dispatch } from '@/state/store';

export const changeLoginWindow = (login: LoginWindowState) => (dispatch: Dispatch) => {
    const changeLoginWindowAction: LoginWindowChangedAction = {
        type: ActionType.SHOW_LOGIN,
        state: login,
    };
    dispatch(changeLoginWindowAction);
};
